// src/components/fundDetailsPage/analysisPanel/AnalysisPanel.jsx

import { useEffect, useState } from "react";

import { Box, Flex, Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { usePathname } from "next/navigation";

import ArrowUpSvg from "@/assets/svg/arrow-high.svg";
import GreenPlusSvg from "@/assets/svg/green-plus.svg";
import { BlockWithBlueArrowTitle } from "@/components/ui/box/BlockWithBlueArrowTitle";
import { CustomElement } from "@/components/ui/box/CustomElement";
import { MainWrapper } from "@/components/ui/box/MainWrapper";
import { useActions } from "@/hooks/useActions";
import { h_400_12_135_48, h_700_14_120_28 } from "@/styles/fontStyles";
import {
  analysisTabsBlock1,
  analysisTabsBlock2,
} from "@/utils/fundDetailsMask";


import AnalysisPanelTablet from "./AnalysisPanelTablet/AnalysisPanelTablet";
import AnalysisPanelTablet2 from "./AnalysisPanelTablet/AnalysisPanelTablet2";
import ChartFund_1 from "./chartFund/ChartFund_1";
import HoldingsAnalysisChart from "./HoldingsAnalysisChart";

export const AnalysisPanel = ({ fundDetails, veryfiedFund }) => {
  const verifiedAnalysisTab = veryfiedFund?.analysisTab;
  const { setFundsDetails } = useActions();
  useEffect(() => {
    if (fundDetails) {
      setFundsDetails(fundDetails);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fundDetails]);

  return (
    <>
      {Object.keys(fundDetails)?.length > 0 && (
        <MainWrapper
          customStyleOuter={{
            px: { base: "8px", md: "40px", xl: "0" },

            mt: { base: "40px", md: "40px", lg2: "60px" },
          }}
          customStyleInner={{
            maxW: { base: "100%", md: "100%", xl: "1124px" },
          }}
        >
          <Flex
            flexDir={"column"}
            gap={{ base: "20px", md: "40px" }}
            display={{ base: "none", lg2: "block" }}
          >
            {verifiedAnalysisTab?.schema1Value
              ? [analysisTabsBlock1(fundDetails)].map((item, index) => {
                  return (
                    <BlockWithBlueArrowTitle
                      key={`${item?.title?.name}-${index}`}
                      title={item?.title?.name}
                      customStyleOuterBox={{
                        borderRadius: "10px",
                        background: "dashboardBackground",
                        boxShadow: "0px 0px 14px 0px rgba(114, 114, 114, 0.25)",
                      }}
                      customStyleInnerBox={{ pb: "30px" }}
                    >
                      <AnalysisBlock {...{ data: item }} />
                    </BlockWithBlueArrowTitle>
                  );
                })
              : null}
          </Flex>
          {/* -------------shema2------------------ */}
          <Flex
            flexDir={"column"}
            gap={{ base: "20px", md: "40px" }}
            display={{ base: "none", lg2: "block" }}
            mt={"20px"}
          >
            {verifiedAnalysisTab?.schema2Value
              ? [analysisTabsBlock2(fundDetails)].map((item, index) => {
                  return (
                    <BlockWithBlueArrowTitle
                      key={`${item?.title?.name}-${index}`}
                      title={item?.title?.name}
                      customStyleOuterBox={{
                        borderRadius: "10px",
                        background: "dashboardBackground",
                        boxShadow: "0px 0px 14px 0px rgba(114, 114, 114, 0.25)",
                      }}
                      customStyleInnerBox={{ pb: "30px" }}
                    >
                      <HoldingsAnalysisChart
                        {...{ data: item, index: index }}
                      />
                    </BlockWithBlueArrowTitle>
                  );
                })
              : null}
          </Flex>
          {/* -------------tablet------------------ */}
          <Flex display={{ base: "block", lg2: "none" }}>
            {verifiedAnalysisTab?.schema1Value
              ? [analysisTabsBlock1(fundDetails)].map((item, index) => {
                  return (
                    <BlockWithBlueArrowTitle
                      key={`${item?.title?.name}-${index}`}
                      title={item?.title?.name}
                      customStyleOuterBox={{
                        borderRadius: "10px",
                        background: "dashboardBackground",
                        boxShadow: "0px 0px 14px 0px rgba(114, 114, 114, 0.25)",
                      }}
                      customStyleInnerBox={{ pb: "30px" }}
                    >
                      <AnalysisPanelTablet
                        {...{ data: item }}
                        variant={"list"}
                      />
                    </BlockWithBlueArrowTitle>
                  );
                })
              : null}
          </Flex>
          <Flex display={{ base: "block", lg2: "none" }}>
            {verifiedAnalysisTab?.schema2Value
              ? [analysisTabsBlock2(fundDetails)].map((item, index) => {
                  return (
                    <BlockWithBlueArrowTitle
                      key={`${item?.title?.name}-${index}`}
                      title={item?.title?.name}
                      customStyleOuterBox={{
                        borderRadius: "10px",
                        background: "dashboardBackground",
                        boxShadow: "0px 0px 14px 0px rgba(114, 114, 114, 0.25)",
                      }}
                      customStyleInnerBox={{ pb: "30px" }}
                    >
                      <AnalysisPanelTablet2
                        {...{ data: item }}
                        variant={"list"}
                      />
                    </BlockWithBlueArrowTitle>
                  );
                })
              : null}
          </Flex>
        </MainWrapper>
      )}
    </>
  );
};

export function AnalysisBlock({ data,  isInvest }) {
  const { setSelectedCardAnalyzeFund  } =
    useActions();
  const handleTabClick = (tab) => {
    setSelectedCardAnalyzeFund(tab);
  };

  return (
    <Grid
      templateAreas={
        isInvest
          ? null
          : {
              base: `"mainParams" "chart" "listParams"`,

              xl: `"chart mainParams" "chart listParams"`,
            }
      }
      templateColumns={isInvest ? null : { base: "1fr", xl: "1fr 1fr" }}
      templateRows={
        isInvest ? null : { base: "auto auto auto", xl: "auto auto" }
      }
      w={"full"}
      gap={{ base: "18px", xl: "12px 16px" }}
    >
      <GridItem area={"mainParams"}>
        <ParamsBlock
          variant={"main"}
          data={data?.mainParams}
          handleTabClick={(item, index) => handleTabClick(item, index)}
        />
      </GridItem>
      <GridItem area={"chart"} w={"100%"}>
        <ChartFund_1 isInvest={true} />
      </GridItem>
      <GridItem area={"listParams"}>
        <ParamsBlock
          variant={"list"}
          data={isInvest ? data?.listParams.slice(0, 2) : data?.listParams}
          handleTabClick={(item, index) => handleTabClick(item, index)}
          isInvest={true}
        />
      </GridItem>
    </Grid>
  );
}

export function ParamsBlock({ variant, data, handleTabClick }) {
  const [selectedCard, setSelectedCard] = useState(data ? data?.[0] : null);
  const { setDefaultCardAnalyzeFund } = useActions();
  const pathName = usePathname();

  useEffect(() => {
    if (data) {
      setDefaultCardAnalyzeFund(data?.[0]);
    }
  }, [data, setDefaultCardAnalyzeFund]);

  const styleVariant = (isSelected) => ({
    p: "12px",
    borderRadius: "10px",
    _hover: "unset",
    cursor: "pointer",
    h: "fit-content",
    w: "full",
    ...(isSelected
      ? {
          bg: "gray.200",
          border: "1px solid",
          borderColor: "gray",
        }
      : variant === "main"
      ? {
          bg: "menuSearchColor",
          border: "1px solid",
          borderColor: "gray",
        }
      : {
          bg: "white",
          boxShadow: "0px 0px 10px 0px rgba(200, 200, 200, 0.25)",
        }),
  });

  const handleTabClickInternal = (item, index) => {
    setSelectedCard(item);
    handleTabClick(item, index);
  };

  return (
    <Flex
      flexDir={"column"}
      gap={{ base: "18px", xl: "12px" }}
      pl={{ base: "0px", xl: "20px" }}
    >
      {pathName === "/investing"
        ? null
        : data?.map((item, index) => {
            const isSelected = selectedCard === item;
            return (
              <CustomElement
                key={`${item?.title}-${index}`}
                variant={"whiteBtn"}
                customStyle={styleVariant(isSelected)}
                handler={() =>
                  pathName === "/investing"
                    ? null
                    : handleTabClickInternal(item, index)
                }
              >
                <Flex flexDir={"column"} w={"full"} gap={"6px"}>
                  <Flex justify={"space-between"} align={"center"}>
                    <Heading as={"h3"} {...h_700_14_120_28} color={"mainBlue"}>
                      {item?.title}
                    </Heading>

                    <Flex align={"flex-start"}>
                      <Text
                        color={"blue"}
                        {...h_700_14_120_28}
                        textAlign={"right"}
                        pt={"3px"}
                      >
                        {item?.value}
                      </Text>
                      {item?.valueAdd && switchValueAdd(item?.valueAdd)}
                    </Flex>
                  </Flex>
                  <Flex justify={"space-between"} align={"center"}>
                    <Text {...h_400_12_135_48} color={"gray"} pt={"3px"}>
                      {item?.secondValue}
                    </Text>
                    {item?.statusTag ? (
                      <CustomElement
                        variant={switchTag(item?.statusTag).variant}
                        title={switchTag(item?.statusTag).title}
                      />
                    ) : item?.statusText ? (
                      <Text {...h_400_12_135_48} color={"gray"} pt={"3px"}>
                        {item?.statusText}
                      </Text>
                    ) : (
                      <Box></Box>
                    )}
                  </Flex>
                </Flex>
              </CustomElement>
            );
          })}
    </Flex>
  );
}

export function switchValueAdd(value) {
  switch (value) {
    case "+":
      return <GreenPlusSvg />;
    case "up":
      return <ArrowUpSvg />;
  }
}

export function switchTag(value) {
  switch (value) {
    case "High":
      return { variant: "smallGreenBtn", title: "Data Confidence: High" };
    case "Low":
      return { variant: "smallRedBtn", title: "Data Confidence: Low" };
    case "Medium":
      return { variant: "smallGrayBtn", title: "Data Confidence: Medium" };
    case "Average+":
      return { variant: "smallGreenBtn", title: "Above Average" };
    case "Average-":
      return { variant: "smallRedBtn", title: "Above Average" };
  }
}
